import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-783ad052"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-coach-players-root-list" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box__headline" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Popis igrača ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "box__list"
}
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "photo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "category" }
const _hoisted_11 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.players.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.players, (player) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    xs: 24,
                    sm: 24,
                    md: 8,
                    lg: 8,
                    xl: 8,
                    key: player.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: { name: 'AppCoachPlayersProfileRootIndexVue', params: { id: player.id} }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("img", {
                                src: _ctx.getAvatar(player.content.avatar),
                                alt: ""
                              }, null, 8, _hoisted_7)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(player.content.name) + " " + _toDisplayString(player.content.surname), 1),
                              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getPlayerCategory(player.content.birthday)), 1)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, " Nema podataka... "))
    ])
  ]))
}